import React from 'react';
import PropTypes from 'prop-types';

export const CloseIcon = ({ style, color = '#C2CEDB' }) => {
   return (
      <svg style={ style } className='close' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0h24v24H0z' />
            <path fill={ color } className='close_path' fillRule='nonzero' d='M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm4.903 12.625c.19.19.19.496 0 .685l-1.597 1.593a.484.484 0 0 1-.685 0L12 14.258l-2.625 2.645a.484.484 0 0 1-.685 0l-1.593-1.597a.484.484 0 0 1 0-.685L9.742 12 7.097 9.375a.484.484 0 0 1 0-.685l1.597-1.597c.19-.19.496-.19.685 0L12 9.742l2.625-2.645c.19-.19.496-.19.685 0l1.597 1.597c.19.19.19.496 0 .685L14.258 12l2.645 2.625z' />
         </g>
      </svg>
   );
};

export const CrossIcon = ({ color = '#C2CEDB' }) => {
   return (
      <svg viewBox='0 0 24 24' width='24' height='24' xmlns='http://www.w3.org/2000/svg' fill='#000000'>
         <g id='SVGRepo_bgCarrier' strokeWidth='0' />
         <g id='SVGRepo_tracerCarrier' strokeLinecap='round' strokeLinejoin='round' />
         <g id='SVGRepo_iconCarrier'>
            <path fill={ color } d='M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z' />
         </g>
      </svg>
   );
};

export const SearchIcon = ({ style, color }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0h24v24H0z' />
            <path d='M0 0h24v24H0z' />
            <path fill={ color } fillRule='nonzero' d='M21.862 20.316l-4.742-4.742a.464.464 0 0 0-.332-.137h-.515A8.123 8.123 0 0 0 10.125 2 8.123 8.123 0 0 0 2 10.125a8.123 8.123 0 0 0 13.437 6.148v.515c0 .125.05.243.137.332l4.742 4.742a.47.47 0 0 0 .664 0l.882-.882a.47.47 0 0 0 0-.664zm-11.737-3.942a6.248 6.248 0 0 1-6.25-6.25 6.248 6.248 0 0 1 6.25-6.25 6.248 6.248 0 0 1 6.25 6.25 6.248 6.248 0 0 1-6.25 6.25z' />
         </g>
      </svg>

   );
};

export const CalendarIcon = () => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='20' viewBox='0 0 18 20'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L24 0 24 24 0 24z' transform='translate(-3 -2)' />
            <path fill='#3F4F65' fillRule='nonzero' d='M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' transform='translate(-3 -2)' />
         </g>
      </svg>
   );
};

export const CalendarCouponIcon = () => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <g fill='none' fillRule='evenodd'>
            <path d='M0 0L24 0 24 24 0 24z' />
            <path fill='#C2CEDB' fillRule='nonzero' d='M17 3h4c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h4V1h2v2h6V1h2v2zm3 6V5h-3v2h-2V5H9v2H7V5H4v4h16zm0 2H4v8h16v-8zM6 13h5v4H6v-4z' />
         </g>
      </svg>
   );
};

export const SelectNewIcon = () => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='16' viewBox='0 0 12 16'>
         <g fill='none' fillRule='evenodd'>
            <path fill='#3F4F65' fillRule='nonzero' d='M17.429 13l-5.715 6.667L6 13h11.429zm-5.715-9l5.715 6.667H6L11.714 4z' transform='translate(-6 -4)' />
            <path d='M0 0H24V24H0z' transform='translate(-6 -4)' />
         </g>
      </svg>
   );
};


export const DeleteIcon = ({ style, color }) => {
   return (
      <svg width='24px' height='24px' style={ style } viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='7.-Sign-Up-Page' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard' transform='translate(-505.175573, -71.000000)'>
               <g id='Input/-Main-Page-Settings-'>
                  <g id='Icon-/-Delete' transform='translate(505.175573, 71.000000)'>
                     <polygon id='Path' points='0 0 24 0 24 24 0 24' />
                     <path
                        d='M4.28571429,20.125 C4.28571429,21.1605339 5.14916513,22 6.21428571,22 L17.7857143,22 C18.8508349,22 19.7142857,21.1605339 19.7142857,20.125 L19.7142857,7 L4.28571429,7 L4.28571429,20.125 Z M15.2142857,10.125 C15.2142857,9.77982203 15.5021027,9.5 15.8571429,9.5 C16.2121831,9.5 16.5,9.77982203 16.5,10.125 L16.5,18.875 C16.5,19.220178 16.2121831,19.5 15.8571429,19.5 C15.5021027,19.5 15.2142857,19.220178 15.2142857,18.875 L15.2142857,10.125 Z M11.3571429,10.125 C11.3571429,9.77982203 11.6449598,9.5 12,9.5 C12.3550402,9.5 12.6428571,9.77982203 12.6428571,10.125 L12.6428571,18.875 C12.6428571,19.220178 12.3550402,19.5 12,19.5 C11.6449598,19.5 11.3571429,19.220178 11.3571429,18.875 L11.3571429,10.125 Z M7.5,10.125 C7.5,9.77982203 7.78781695,9.5 8.14285714,9.5 C8.49789734,9.5 8.78571429,9.77982203 8.78571429,10.125 L8.78571429,18.875 C8.78571429,19.220178 8.49789734,19.5 8.14285714,19.5 C7.78781695,19.5 7.5,19.220178 7.5,18.875 L7.5,10.125 Z M20.3571429,3.25 L15.5357143,3.25 L15.1580357,2.51953125 C14.9948476,2.20099326 14.660226,1.99974477 14.2941964,2 L9.70178571,2 C9.33644453,1.99863457 9.00245414,2.20044211 8.84196429,2.51953125 L8.46428571,3.25 L3.64285714,3.25 C3.28781695,3.25 3,3.52982203 3,3.875 L3,5.125 C3,5.47017797 3.28781695,5.75 3.64285714,5.75 L20.3571429,5.75 C20.7121831,5.75 21,5.47017797 21,5.125 L21,3.875 C21,3.52982203 20.7121831,3.25 20.3571429,3.25 Z'
                        id='Shape'
                        fill={ color }
                        fillRule='nonzero'
                     />
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
};

export const CloseXIcon = () => {
   return (
      <svg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='Symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Icon-/-Close-'>
               <rect id='Rectangle' x='0' y='0' width='24' height='24' />
               <path d='M13.7692677,12.0002085 L21.6343472,4.13512894 C22.1229961,3.64689695 22.1229961,2.85471867 21.6343472,2.36648669 C21.1456983,1.87783777 20.3543539,1.87783777 19.8657049,2.36648669 L12.0006254,10.2315662 L4.13512894,2.36648669 C3.64648002,1.87783777 2.85513561,1.87783777 2.36648669,2.36648669 C1.87783777,2.85471867 1.87783777,3.64689695 2.36648669,4.13512894 L10.2319832,12.0002085 L2.36648669,19.865288 C1.87783777,20.35352 1.87783777,21.1456983 2.36648669,21.6339302 C2.61081115,21.8778378 2.93101795,22 3.25080781,22 C3.57059768,22 3.89080448,21.8778378 4.13512894,21.6335133 L12.0006254,13.7684338 L19.8657049,21.6335133 C20.1100294,21.8778378 20.4302362,22 20.7500261,22 C21.0698159,22 21.3900227,21.8778378 21.6343472,21.6335133 C22.1229961,21.1452813 22.1229961,20.353103 21.6343472,19.8648711 L13.7692677,12.0002085 Z' id='Path' fill='#3F4F65' fillRule='nonzero' />
            </g>
         </g>
      </svg>
   );
};

export const CloseXNewIcon = ({ color }) => {
   return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <g id='Icon-/-Close-' fill='none' fillRule='evenodd'>
            <path d='M0 0H24V24H0z' />
            <path fill={ color || '#3F4F65' } fillRule='nonzero' d='M13.77 12l7.864-7.865c.489-.488.489-1.28 0-1.769-.488-.488-1.28-.488-1.768 0L12 10.232 4.135 2.366c-.489-.488-1.28-.488-1.769 0-.488.489-.488 1.28 0 1.77L10.232 12l-7.866 7.865c-.488.489-.488 1.28 0 1.769.245.244.565.366.885.366.32 0 .64-.122.884-.366l7.866-7.866 7.865 7.866c.244.244.564.366.884.366.32 0 .64-.122.884-.366.489-.489.489-1.28 0-1.77L13.77 12z' />
         </g>
      </svg>
   );
};


export const AddIcon = ({ style, color }) => {
   return (
      <svg width='40px' height='40px' style={ style } viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='9.-Students-Room' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard'>
               <g id='Icon-/-Add'>
                  <polygon id='Path' points='0 0 40 0 40 40 0 40' />
                  <path
                     d='M28.6021505,18.9247312 L28.6021505,21.0752688 C28.6021505,21.5188172 28.2392473,21.8817204 27.7956989,21.8817204 L21.8817204,21.8817204 L21.8817204,27.7956989 C21.8817204,28.2392473 21.5188172,28.6021505 21.0752688,28.6021505 L18.9247312,28.6021505 C18.4811828,28.6021505 18.1182796,28.2392473 18.1182796,27.7956989 L18.1182796,21.8817204 L12.2043011,21.8817204 C11.7607527,21.8817204 11.3978495,21.5188172 11.3978495,21.0752688 L11.3978495,18.9247312 C11.3978495,18.4811828 11.7607527,18.1182796 12.2043011,18.1182796 L18.1182796,18.1182796 L18.1182796,12.2043011 C18.1182796,11.7607527 18.4811828,11.3978495 18.9247312,11.3978495 L21.0752688,11.3978495 C21.5188172,11.3978495 21.8817204,11.7607527 21.8817204,12.2043011 L21.8817204,18.1182796 L27.7956989,18.1182796 C28.2392473,18.1182796 28.6021505,18.4811828 28.6021505,18.9247312 Z M36.6666667,20 C36.6666667,29.2069892 29.2069892,36.6666667 20,36.6666667 C10.7930108,36.6666667 3.33333333,29.2069892 3.33333333,20 C3.33333333,10.7930108 10.7930108,3.33333333 20,3.33333333 C29.2069892,3.33333333 36.6666667,10.7930108 36.6666667,20 Z M33.4408602,20 C33.4408602,12.5739247 27.4260753,6.55913978 20,6.55913978 C12.5739247,6.55913978 6.55913978,12.5739247 6.55913978,20 C6.55913978,27.4260753 12.5739247,33.4408602 20,33.4408602 C27.4260753,33.4408602 33.4408602,27.4260753 33.4408602,20 Z'
                     id='Shape'
                     fill={ color }
                     fillRule='nonzero'
                  />
               </g>
            </g>
         </g>
      </svg>
   );
};

export const PauseIcon = ({ style, color }) => {
   return (
      <svg width='32px' height='32px' style={ style } viewBox='0 0 32 32' version='1.1' xmlns='http://www.w3.org/2000/svg'>
         <g id='14.-Members' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Artboard' transform='translate(-630.000000, -34.000000)'>
               <g id='Card-/-Manage-/-Courses'>
                  <g id='Icon-/-Stop' transform='translate(630.000000, 34.000000)'>
                     <rect id='Rectangle' x='0' y='0' width='32' height='32' />
                     <path
                        d='M16,2.66666667 C8.6344086,2.66666667 2.66666667,8.6344086 2.66666667,16 C2.66666667,23.3655914 8.6344086,29.3333333 16,29.3333333 C23.3655914,29.3333333 29.3333333,23.3655914 29.3333333,16 C29.3333333,8.6344086 23.3655914,2.66666667 16,2.66666667 Z M15.1397849,20.3010753 C15.1397849,20.7741935 14.7526882,21.1612903 14.2795699,21.1612903 L11.6989247,21.1612903 C11.2258065,21.1612903 10.8387097,20.7741935 10.8387097,20.3010753 L10.8387097,11.6989247 C10.8387097,11.2258065 11.2258065,10.8387097 11.6989247,10.8387097 L14.2795699,10.8387097 C14.7526882,10.8387097 15.1397849,11.2258065 15.1397849,11.6989247 L15.1397849,20.3010753 Z M21.1612903,20.3010753 C21.1612903,20.7741935 20.7741935,21.1612903 20.3010753,21.1612903 L17.7204301,21.1612903 C17.2473118,21.1612903 16.8602151,20.7741935 16.8602151,20.3010753 L16.8602151,11.6989247 C16.8602151,11.2258065 17.2473118,10.8387097 17.7204301,10.8387097 L20.3010753,10.8387097 C20.7741935,10.8387097 21.1612903,11.2258065 21.1612903,11.6989247 L21.1612903,20.3010753 Z'
                        id='Shape'
                        fill={ color }
                        fillRule='nonzero'
                     />
                  </g>
               </g>
            </g>
         </g>
      </svg>
   );
};
export const DownlodItemIcon = ({ style, color }) => {
   return (
      <svg style={ style } xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
         <defs>
            <path id='prefix__a' d='M14.016 6l-7.032 6.984L0 6h3.984V0h6v6h4.032zM0 15h14.016v2.016H0V15z' />
         </defs>
         <g fill='none' fillRule='evenodd' transform='translate(5 3)'>
            <use fill={ color } xlinkHref='#prefix__a' />
         </g>
      </svg>
   );
};

export const SelectCalendarIcon = ({ className }) => {
   return (
      <svg className={ className } width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <path fillRule='evenodd' clipRule='evenodd' d='M6.16663 0.833008C6.16663 0.556865 5.94278 0.333008 5.66663 0.333008C5.39049 0.333008 5.16663 0.556865 5.16663 0.833008V1.34914C5.00872 1.38217 4.85803 1.42115 4.71205 1.46718C2.68948 2.10489 1.10519 3.68919 0.467473 5.71175C0.166466 6.66643 0.166525 7.82265 0.16663 9.8824L0.166634 9.99968L0.16663 10.1169C0.166525 12.1767 0.166466 13.3329 0.467473 14.2876C1.10519 16.3102 2.68948 17.8945 4.71205 18.5322C5.66672 18.8332 6.82295 18.8331 8.88271 18.833L8.99997 18.833L9.11723 18.833C11.177 18.8331 12.3332 18.8332 13.2879 18.5322C15.3105 17.8945 16.8947 16.3102 17.5325 14.2876C17.8335 13.3329 17.8334 12.1767 17.8333 10.1169L17.8333 9.99968L17.8333 9.88242C17.8334 7.82265 17.8335 6.66643 17.5325 5.71175C16.8947 3.68919 15.3105 2.10489 13.2879 1.46718C13.1419 1.42115 12.9912 1.38217 12.8333 1.34914V0.833008C12.8333 0.556865 12.6094 0.333008 12.3333 0.333008C12.0572 0.333008 11.8333 0.556865 11.8333 0.833008V1.21777C11.1265 1.16623 10.2612 1.16628 9.11724 1.16634L8.99997 1.16634L8.8827 1.16634C7.73872 1.16628 6.87346 1.16623 6.16663 1.21777V0.833008ZM11.8333 3.33301V2.22015C11.1712 2.16835 10.2953 2.16634 8.99997 2.16634C7.70465 2.16634 6.8287 2.16835 6.16663 2.22015V3.33301C6.16663 3.60915 5.94278 3.83301 5.66663 3.83301C5.39049 3.83301 5.16663 3.60915 5.16663 3.33301V2.37615C5.11434 2.39011 5.06314 2.40501 5.01275 2.4209C3.30135 2.9605 1.96079 4.30106 1.42119 6.01246C1.17247 6.80131 1.16663 7.79068 1.16663 9.99968C1.16663 12.2087 1.17247 13.198 1.42119 13.9869C1.96079 15.6983 3.30135 17.0388 5.01275 17.5785C5.8016 17.8272 6.79097 17.833 8.99997 17.833C11.209 17.833 12.1983 17.8272 12.9872 17.5785C14.6986 17.0388 16.0391 15.6983 16.5787 13.9869C16.8275 13.198 16.8333 12.2087 16.8333 9.99968C16.8333 7.79068 16.8275 6.80131 16.5787 6.01246C16.0391 4.30106 14.6986 2.9605 12.9872 2.4209C12.9368 2.40501 12.8856 2.39011 12.8333 2.37615V3.33301C12.8333 3.60915 12.6094 3.83301 12.3333 3.83301C12.0572 3.83301 11.8333 3.60915 11.8333 3.33301ZM4.8333 6.16634C4.55716 6.16634 4.3333 6.3902 4.3333 6.66634C4.3333 6.94248 4.55716 7.16634 4.8333 7.16634H13.1666C13.4428 7.16634 13.6666 6.94248 13.6666 6.66634C13.6666 6.3902 13.4428 6.16634 13.1666 6.16634H4.8333Z' fill='#131F1E' />
      </svg>
   );
};

// Prop Types

SelectCalendarIcon.propTypes = {
   className: PropTypes.string,
};

SearchIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

CloseIcon.propTypes = {
   style: PropTypes.object,
   color: PropTypes.string,
};

CrossIcon.propTypes = {
   color: PropTypes.string,
};

PauseIcon.propTypes = {
   style: PropTypes.object,
   color: PropTypes.string,
};

AddIcon.propTypes = {
   style: PropTypes.object,
   color: PropTypes.string,
};

DeleteIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};
DownlodItemIcon.propTypes = {
   color: PropTypes.string,
   style: PropTypes.object,
};

CloseXNewIcon.propTypes = {
   color: PropTypes.string,
};

// Default props

SearchIcon.defaultProps = {
   color: '#C2CEDB',
};

DeleteIcon.defaultProps = {
   color: '#C2CEDB',
};

AddIcon.defaultProps = {
   color: '#3F4F65',
};

PauseIcon.defaultProps = {
   color: '#C2CEDB',
};
DownlodItemIcon.defaultProps = {
   color: '#C2CEDB',
};
